export const USD_TO_CAD_CONVERSION_RATE = 1.28;
